import { render, staticRenderFns } from "./point-a.vue?vue&type=template&id=728fe05c&scoped=true&"
import script from "./point-a.vue?vue&type=script&lang=js&"
export * from "./point-a.vue?vue&type=script&lang=js&"
import style0 from "./point-a.vue?vue&type=style&index=0&id=728fe05c&prod&scoped=true&lang=css&"
import style1 from "./point-a.vue?vue&type=style&index=1&id=728fe05c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fe05c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VChip,VContent,VDivider,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems})
